export default "__VITE_ASSET__Cqwog0si__"